import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center space-x-4" }

import { ref } from "vue";

import TitleHeader from "@/components/TitleHeader.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";

import api from "@/api/api";
import { EmailList } from "@/types";
import { useGlobalStore } from "@/store";
import { slugify } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailPreference',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();

const lists = ref([] as EmailList[]);
const userLists = ref([] as string[]);

function isUserInList(list_id: EmailList["brevo_id"]) {
  if (userLists.value.find(i => String(i) == String(list_id))) return true;
  return false;
}

async function toggleUserInList(list_id: EmailList["id"]) {
  try {
    const response = await api.brevo.toggleUserOnList(list_id);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", response.data.message);
      await getUserLists();
    }
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error updating email preferences");
  }
}

async function getUserLists() {
  userLists.value = (await api.brevo.getContactInfo()).data.lists;
}

lists.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.brevo.listEmailLists())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.lists;

console.log(lists.value);

;(
  ([__temp,__restore] = _withAsyncContext(() => getUserLists())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('email-preferences')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (list) => {
        return (_openBlock(), _createElementBlock("div", {
          key: list.id,
          class: "mt-4"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(_unref(slugify)(list.name))), 1),
            _createVNode(ToggleCheckbox, {
              value: isUserInList(list.brevo_id),
              onToggle: ($event: any) => (toggleUserInList(list.brevo_id))
            }, null, 8, ["value", "onToggle"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})